/**
 * @desc Overrides for the uib-typeahead component
 */
;(function () {
  angular.module('app.ui.directives.typeahead', [])
})()

/**
 * @desc override to uib-typeahead that loads results on focus.
 *       the corresponding ngModel cannot use debounce.
 * @example <input uib-typeahead="..." typeahead-click-open>
 */
;(function () {
  angular
    .module('app.ui.directives.typeahead')
    .directive('typeaheadClickOpen', typeaheadClickOpen)

  function typeaheadClickOpen($) {
    'ngInject'

    var directive = {
      restrict: 'A',
      require: 'ngModel',
      link: link
    }
    return directive

    function link(scope, element, attrs, ctrl) {
      element.on('focus', function () {
        ctrl.$setViewValue()
        $(element).trigger('input')
        $(element).trigger('change')
      })

      ctrl.$parsers.unshift(function (inputValue) {
        var value = inputValue ? inputValue : ''
        ctrl.$viewValue = value

        return value
      })

      ctrl.$parsers.push(function (inputValue) {
        return inputValue === '' ? '' : inputValue
      })
    }
  }
})()
